import { RiAlignCenter, RiAlignJustify, RiAlignLeft, RiAlignRight, RiArrowDownSLine, RiBold, RiCloseFill, RiColorFilterFill, RiFormatClear, RiH1, RiH2, RiH3, RiH4, RiItalic, RiListOrdered, RiListUnordered, RiStrikethrough, RiText, RiUnderline, } from '@remixicon/react';
import { useEditorState } from '@tiptap/react';
import React, { useRef, useState } from 'react';
import { styled } from 'styled-components';
import { OutsideClick } from '../OutsideClick.js';
const FONT_SIZES = [
    { label: '10px', value: '10px' },
    { label: '12px', value: '12px' },
    { label: '14px', value: '14px' },
    { label: '16px', value: '16px' },
    { label: '18px', value: '18px' },
    { label: '20px', value: '20px' },
    { label: '24px', value: '24px' },
    { label: '28px', value: '28px' },
    { label: '32px', value: '32px' },
    { label: '36px', value: '36px' },
    { label: '48px', value: '48px' },
    { label: '64px', value: '64px' },
];
export const Marks = (props) => {
    const editor = props.editor;
    const editorState = useEditorState({
        editor,
        // the selector function is used to select the state you want to react to
        selector: ({ editor }) => {
            if (!editor) {
                return null;
            }
            return {
                isBold: editor.isActive('bold'),
                isItalic: editor.isActive('italic'),
                isUnderlined: editor.isActive('underline'),
                isStriked: editor.isActive('strike'),
                isH1: editor.isActive('heading', { level: 1 }),
                isH2: editor.isActive('heading', { level: 2 }),
                isH3: editor.isActive('heading', { level: 3 }),
                isH4: editor.isActive('heading', { level: 4 }),
                isParagraph: editor.isActive('paragraph'),
                isAlignedLeft: editor.isActive({ textAlign: 'left' }),
                isAlignedCenter: editor.isActive({ textAlign: 'center' }),
                isAlignedRight: editor.isActive({ textAlign: 'right' }),
                isAlignedJustify: editor.isActive({ textAlign: 'justify' }),
                isBulletList: editor.isActive('bulletList'),
                isOrderedList: editor.isActive('orderedList'),
                color: editor.getAttributes('textStyle').backgroundColor,
                fontSize: editor.getAttributes('textStyle').fontSize,
            };
        },
    });
    const [fontSizeOpen, setFontSizeOpen] = useState(false);
    const fontSizeRef = useRef(null);
    const currentFontSize = editorState?.fontSize || '16px';
    return (React.createElement(Wrapper, null,
        React.createElement(Mark, { onClick: () => editor.chain().focus().setParagraph().run(), active: editorState?.isParagraph },
            React.createElement(RiText, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleHeading({ level: 1 }).run(), active: editorState?.isH1 },
            React.createElement(RiH1, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleHeading({ level: 2 }).run(), active: editorState?.isH2 },
            React.createElement(RiH2, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleHeading({ level: 3 }).run(), active: editorState?.isH3 },
            React.createElement(RiH3, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleHeading({ level: 4 }).run(), active: editorState?.isH4 },
            React.createElement(RiH4, { size: 16 })),
        React.createElement(VerticalLine, null),
        React.createElement(FontSizePickerWrapper, { ref: fontSizeRef },
            React.createElement(Mark, { onClick: () => setFontSizeOpen(!fontSizeOpen), active: fontSizeOpen },
                React.createElement(FontSizeButton, null,
                    React.createElement(FontSizeLabel, null, currentFontSize),
                    React.createElement(RiArrowDownSLine, { size: 16 }))),
            React.createElement(OutsideClick, { isOpen: fontSizeOpen, reference: fontSizeRef, onOutsideClick: () => setFontSizeOpen(false) }, fontSizeOpen && (React.createElement(FontSizeDropdown, null, FONT_SIZES.map((size) => (React.createElement(FontSizeMenuItem, { key: size.value, onClick: () => {
                    editor.chain().focus().setFontSize(size.value).run();
                    setFontSizeOpen(false);
                } }, size.label))))))),
        React.createElement(VerticalLine, null),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleBold().run(), active: editorState?.isBold },
            React.createElement(RiBold, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleItalic().run(), active: editorState?.isItalic },
            React.createElement(RiItalic, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleUnderline().run(), active: editorState?.isUnderlined },
            React.createElement(RiUnderline, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleStrike().run(), active: editorState?.isStriked },
            React.createElement(RiStrikethrough, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().unsetAllMarks().run(), active: false },
            React.createElement(RiFormatClear, { size: 16 })),
        React.createElement(VerticalLine, null),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleTextAlign('left').run(), active: editorState?.isAlignedLeft },
            React.createElement(RiAlignLeft, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleTextAlign('center').run(), active: editorState?.isAlignedCenter },
            React.createElement(RiAlignCenter, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleTextAlign('right').run(), active: editorState?.isAlignedRight },
            React.createElement(RiAlignRight, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleTextAlign('justify').run(), active: editorState?.isAlignedJustify },
            React.createElement(RiAlignJustify, { size: 16 })),
        React.createElement(VerticalLine, null),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleBulletList().run(), active: editorState?.isBulletList },
            React.createElement(RiListUnordered, { size: 16 })),
        React.createElement(Mark, { onClick: () => editor.chain().focus().toggleOrderedList().run(), active: editorState?.isOrderedList },
            React.createElement(RiListOrdered, { size: 16 })),
        React.createElement(Mark, { active: editorState?.color },
            React.createElement("label", { style: { display: 'block' } },
                React.createElement(RiColorFilterFill, { size: 16, style: {
                        background: editorState?.color ?? 'none',
                        borderRadius: '3px',
                        display: 'block',
                        cursor: 'pointer',
                    } }),
                React.createElement(ColorInput, { type: "color", onInput: (event) => editor
                        .chain()
                        .focus()
                        .setBackgroundColor(event.currentTarget.value)
                        .run(), value: editorState?.color }))),
        editorState?.color != null ? (React.createElement(Mark, { onClick: () => editor.chain().focus().unsetBackgroundColor().run(), active: false },
            React.createElement(RiCloseFill, { style: {
                    background: editorState?.color ?? 'none',
                    borderRadius: '3px',
                }, size: 16 }))) : null));
};
const Mark = styled.div `
  display: block;
  border-radius: 3px;
  padding: 5px;
  cursor: pointer;

  & * {
    display: block;
  }

  &:hover {
    background-color: lightgray;
  }

  background-color: ${(props) => (props.active ? 'lightgray' : 'white')};
`;
const ColorInput = styled.input `
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  border: none;
`;
const Wrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding: 5px;
  border-bottom: 1px solid lightgray;
  /*justify-content: center;*/
`;
const VerticalLine = styled.div `
  width: 1px;
  background: lightgray;
`;
const FontSizePickerWrapper = styled.div `
  position: relative;
`;
const FontSizeButton = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
`;
const FontSizeLabel = styled.span `
  font-size: 12px;
  min-width: 28px;
`;
const FontSizeDropdown = styled.div `
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid lightgray;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  min-width: 80px;
`;
const FontSizeMenuItem = styled.div `
  padding: 4px 8px;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;

  &:hover {
    background-color: lightgray;
  }
`;
//# sourceMappingURL=Marks.js.map